import { render, staticRenderFns } from "./TagDropdown.vue?vue&type=template&id=06d8a366&scoped=true"
import script from "./TagDropdown.vue?vue&type=script&lang=js"
export * from "./TagDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d8a366",
  null
  
)

export default component.exports